var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"shop-car-header mb-20 flex items-center justify-between"},[_c('h2',{staticClass:"flex items-center"},[_c('icon',{staticClass:"car-icon",attrs:{"icon-name":_vm.icon}}),_c('span',{staticClass:"shop-car-header-title"},[_vm._v(_vm._s(_vm.title))])],1),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }